import { UI_PRIMITIVE__card_content } from '@/components/ui/card/card';
import { CONSTANTS__environment_client } from '@/constants/CONSTANTS__environment_client';
import { ENUM__html_ref_stub } from '@/enums/ENUM__html_ref_stub';
import { Key } from '@/enums/key';
import { use_ref_with_fallback } from '@/hooks/_base/use_ref_with_fallback';
import i18n_page_auth from '@/locales/keys/i18n_page_auth.json';
import { ENUM__i18n_namespace } from '@/services/i18n/ENUM__i18n_namespace';
import { md } from '@/utils/utils_html';
import { ENUM__environment_type } from '@shared/enums/ENUM__environment_type';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { WatcherAuthInputAcceptValue } from '../_watchers/watcher_shortcut_auth_input_accept_value';
import { A_BUTTON__auth_email_and_password } from '../buttons/A_BUTTON__auth_email_and_password';
import { ButtonAuthMagicLink } from '../buttons/ButtonAuthEmailMagicLink';
import { A_INPUT__email } from '../inputs/A_INPUT__email';
import { A_INPUT__password } from '../inputs/A_INPUT__password';

export function ViewEnterWithEmail() {
  const { t } = useTranslation(ENUM__i18n_namespace.PAGE_AUTH);

  const [email, set_email] = useState(
    CONSTANTS__environment_client.VITE_APP_ENVIRONMENT === ENUM__environment_type.LOCAL ? CONSTANTS__environment_client.VITE_AUTH_TEST_USER_EMAIL : '',
  );
  const [password, set_password] = useState(
    CONSTANTS__environment_client.VITE_APP_ENVIRONMENT === ENUM__environment_type.LOCAL ? CONSTANTS__environment_client.VITE_AUTH_TEST_USER_PASSWORD : '',
  );

  const ref_email = use_ref_with_fallback(ENUM__html_ref_stub.INPUT);
  const ref_password = use_ref_with_fallback(ENUM__html_ref_stub.INPUT);
  const ref_button_auth_email_and_password = use_ref_with_fallback(ENUM__html_ref_stub.BUTTON);
  const ref_button_auth_magic_link = use_ref_with_fallback(ENUM__html_ref_stub.BUTTON);

  /*
   * EVENTS
   */

  function onKeyDown(e: React.KeyboardEvent<HTMLDivElement>) {
    if (e.key == Key.Enter) on_pressed_enter();

    if (e.key == Key.Escape) on_pressed_escape();
  }

  function on_pressed_enter() {
    if (document.activeElement === ref_email.current) {
      ref_password.current.focus();
    } else if (document.activeElement === ref_password.current) {
      password.trim() ? ref_button_auth_email_and_password.current.click() : ref_button_auth_magic_link.current.click();
    }
  }
  function on_pressed_escape() {
    if (document.activeElement === ref_email.current || document.activeElement === ref_password.current) {
      (document.activeElement as HTMLElement).blur();
    }
  }

  /*
   * HTML
   */

  return (
    <>
      <WatcherAuthInputAcceptValue {...{ password, ref_email, ref_password, ref_button_auth_email_and_password, ref_button_auth_magic_link }} />
      <UI_PRIMITIVE__card_content className="p-0 text-bar-foreground" tabIndex={0} {...{ onKeyDown }}>
        <h2 className={`mb-4 text-lg font-semibold ${md('text-center font-bold', '')}`}>{t(i18n_page_auth.auth_component.title.login_with_email)}</h2>
        <div className={`h-[14.5rem] justify-between flex flex-col ${md('h-[16rem] mt-10', '')}`}>
          <A_INPUT__email ref={ref_email} value={email} onChange={e => set_email(e.target.value)} />
          <A_INPUT__password ref={ref_password} value={password} onChange={e => set_password(e.target.value)} />
          <A_BUTTON__auth_email_and_password ref={ref_button_auth_email_and_password} {...{ password, email }} />
          <ButtonAuthMagicLink ref={ref_button_auth_magic_link} email={email} />
        </div>
      </UI_PRIMITIVE__card_content>
    </>
  );
}
